/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Principle_2_TitleInputs */

const en_about_principle_2_title = /** @type {(inputs: About_Principle_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clarity while we build.`)
};

const lv_about_principle_2_title = /** @type {(inputs: About_Principle_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skaidrība izstrādes laikā.`)
};

/**
* | output |
* | --- |
* | "Clarity while we build." |
*
* @param {About_Principle_2_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_principle_2_title = /** @type {((inputs?: About_Principle_2_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Principle_2_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_principle_2_title(inputs)
	return en_about_principle_2_title(inputs)
});